import { SET_BLOGS, SET_BLOG } from '../actions/blogs';

let initialState = {
  blogsData: [],
  blogData: null,
};

const blogs = (state = initialState, action) => {
  switch (action.type) {
    case SET_BLOGS:
      return {
        ...state,
        blogsData: action.payload,
      };

    case SET_BLOG:
      return {
        ...state,
        blogData: action.payload,
      };

    default:
      return state;
  }
};

export default blogs;
